import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { useParams } from "react-router-dom";
import "./Servicios.css";
import "./ServiciosMedia.css"
import CarouselControls from "../CarouselControls/CarouselControls";

// Importa las imágenes
import paneles_serv from "./paneles_serv.png";
import const_serv from "./const_serv.png";
import casa_serv from "./casa_serv.png";

// Datos para cada slide del carrusel
const slidesData = [
  {
    id: 0,
    backgroundImage: paneles_serv,
    title: "Energía Solar Fotovoltaica",
    subtitle: "Nuestros servicios",
    leftColumn: [
      "Es la división del grupo que se centra exclusivamente en convertir la luz solar en electricidad, de la manera más eficiente, sostenible y rentable posible. La rentabilidad de los proyectos de CNGroup está muy por encima de la media del sector debido a su amplia experiencia y a su tecnología de última generación.",
      "El equipo de ingenieros analiza y plantea de forma personalizada los diferentes tipos de proyectos para diseñar soluciones a medida que optimicen el rendimiento energético de cada inversión. "],
    rightColumn: [
      "CNGroup opera dos líneas de actuación:",
      "División Suelos: Orientada a las necesidades e intereses de propietarios de terrenos y desarrolladores fotovoltaicos, esta división diseña huertos solares o campos generadores optimizados.",
      "División Cubiertas: Estudia y plantea la solución de inversión ideal para ubicar instalaciones fotovoltaicas en cubiertas planas o inclinadas, ya sea una vivienda, nave industrial o cualquier otro tipo de establecimiento."
    ]
  },
  {
    id: 1,
    backgroundImage: casa_serv,
    title: "Promoción Inmobiliaria",
    subtitle: "Nuestros servicios",
    leftColumn: [
      "CN Real Estate es el área del CNGroup que se encarga específicamente del desarrollo y comercialización de productos inmobiliarios que hacen uso de las energías sostenibles. Es por esto que todos los inmuebles que comercializamos tienen paneles solares fotovoltaicos."
    ],
    rightColumn: [
      "Nos encargamos de controlar todas las fases del proyecto a fin de cumplir con las expectativas de nuestros clientes y nuestros estándares de calidad. Acompañamos a nuestros clientes desde la selección de la ubicación, el diseño de la vivienda basado en sus necesidades y supervisamos la posterior ejecución del proyecto hasta su debida finalización"
    ]
  },
  {
    id: 2,
    backgroundImage: const_serv,
    title: "Obra Civil y Edificación",
    subtitle: "Nuestros servicios",
    leftColumn: [
      "Estamos comprometidos con el desarrollo social-económico sostenible de nuestro continente. Planeamos y ejecutamos obras civiles de calidad con los más altos estándares de seguridad para nuestros empleados.",
      "Actualmente operamos en diferentes áreas de España para clientes públicos y privados a través de la ejecución, mantenimiento y conservación de infraestructuras relacionadas al aprovechamiento de energía sostenible. "

    ],
    rightColumn: [
      "Nuestro equipo humano está capacitado y cuenta con la experiencia que nos permite lograr llevar a feliz término los proyectos en los que trabajamos de la mano de nuestros clientes, proveedores y colaboradores. El excelente trabajo de nuestro equipo nos ha permitido año a año posicionarnos como una de las empresas pioneras de nuestro campo."
    ]
  }
];

const Servicios = () => {
  const { slideIndex } = useParams();
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = slidesData.length;
  const currentData = slidesData[currentSlide];

  useEffect(() => {
    if (slideIndex !== undefined) {
      const index = parseInt(slideIndex);
      if (!isNaN(index) && index >= 0 && index < totalSlides) {
        setCurrentSlide(index);
        window.scrollTo(0, 0);
      }
    }
  }, [slideIndex, totalSlides]);

  const nextSlide = () => {
    const newIndex = currentSlide === totalSlides - 1 ? 0 : currentSlide + 1;
    setCurrentSlide(newIndex);
  };

  const prevSlide = () => {
    const newIndex = currentSlide === 0 ? totalSlides - 1 : currentSlide - 1;
    setCurrentSlide(newIndex);
  };

  const goToSlide = (index) => {
    if (index >= 0 && index < totalSlides) {
      setCurrentSlide(index);
    }
  };

  return (
    <div className="servicios-page">
      {/* Agrega estos contenedores como en CNgroup */}
      <div
        className="background-container-servicios"
        style={{ backgroundImage: `url(${currentData.backgroundImage})` }}
      ></div>
      <div className="overlay-dark"></div>

      <Navbar />
      {/* Contenedor principal del carrusel */}
      <div className="carousel-container">
        <div className="carousel-content">
          <div className="servicios-container-wrapper">
            <div className="text-content">
              <p className="servicios-subtitle">{currentData.subtitle}</p>
              <h1 className="servicios-title">{currentData.title}</h1>

              {/* Contenedor de dos columnas */}
              <div className="two-columns-container">
                {/* Columna izquierda */}
                <div className="column-left">
                  {Array.isArray(currentData.leftColumn) ? (
                    currentData.leftColumn.map((paragraph, index) => (
                      <p key={`left-${index}`}>{paragraph}</p>
                    ))
                  ) : (
                    <p>{currentData.leftColumn}</p>
                  )}
                </div>

                {/* Columna derecha */}
                <div className="column-right">
                  {Array.isArray(currentData.rightColumn) ? (
                    currentData.rightColumn.map((paragraph, index) => (
                      <p key={`right-${index}`}>{paragraph}</p>
                    ))
                  ) : (
                    <p>{currentData.rightColumn}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* Usa el componente CarouselControls aquí */}
        <CarouselControls
          totalSlides={totalSlides}
          currentSlide={currentSlide}
          onNext={nextSlide}
          onPrev={prevSlide}
          onDotClick={goToSlide}
          variant="bar"
          position="absolute"
          className="servicios-carousel-controls"
        />
      </div>

      <Footer />
    </div>
  );
};

export default Servicios;